import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import InformationIcon from "../information_icon";
import DropdownMenu from "../dropdown_menu";

const TopBorder = styled.div`
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  height: 7px;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
  background-color: #FCFCFC;
  transition: background-color 250ms;
`;

const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  flex: 1 1 0px;
  padding: 24px;
  background-color: white;
  cursor: pointer;
  border-radius: var(--navigation-border-radius, 8px);
  box-shadow: 0px 2px 4px 0px rgba(0,0,0, 0.15);
  transition: transform 250ms, margin-top 250ms, margin-bottom 250ms, box-shadow 250ms;
  margin-bottom: 0px;
  ${props => !props.active ? 'pointer-events: none; opacity: 0.5' : ''}
`;

const ContainerWrapper = styled.div`
  display: flex;
  flex: 1 1 0px;

  ${props => props.active ? `
    :hover {
      ${Container} {
        ${TopBorder} {
          background-color: ${props.secondaryColor || '#008a16'};
        }
        box-shadow: 0px 2px 4px 0px rgba(0,0,0, 0.15);
        margin-top: -8px;
        margin-bottom: 8px;
      }
    }
  ` : ''}
`;

const TitleWrapper = styled.div`
  display: flex;
  flex-flow: column wrap;
`;

const TitleInfoWrapper = styled.div`
  box-sizing: content-box;
  color: rgb(160, 164, 168);
  font-size: 14px;
  line-height: 19px;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  margin-bottom: 5px;
`;

const ConfigurationNameWrapper = styled.div `
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 12px;
`;

const Title = styled.h4`
  display: flex;
  align-items: center;
  font-weight: bold;
  text-align: left;
  margin-top: 0;
  font-size: 18px !important;
  text-align: left !important;
  color: #333333;
`;

const Description = styled.p`
  margin: 0;
  font-size: 13px !important;
  line-height: 15px !important;
  color: #626469;
  font-weight: 700;
`;

const AdditionalDescription = styled(Description)`
  font-size: 13px;
  line-height: 15px;
  margin-top: 5px;
  margin-bottom: 5px;
  font-weight: 400;
`;

const StartLabelWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
`;

const StartLabel = styled.span`
  color: ${props => props.primaryColor || '0075a3'};
  font-size: 14px;

  ${Container}:hover & {
    text-decoration: underline;
  }
`;

const AlignBottom = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 0px;
  justify-content: flex-end;
`;

const PreventExpand = styled.div`
  display: inline-flex;
`;

const TechnologyHintWrapper = styled.div`
  margin-left: 5px;
  color: #626469;
`;

const TechnologyHint = styled.div`
  padding: 10px;
  min-width: 200px;
  font-size: 14px;
  white-space: pre-wrap;
`;

class StartConfigurationCard extends React.Component {

  static propTypes = {
    id: PropTypes.string,
    title: PropTypes.string.isRequired,
    technologyHint: PropTypes.string,
    onSelection: PropTypes.func,
    description: PropTypes.string,
    additionalDescription: PropTypes.string,
    renderSelectedFilters: PropTypes.func,
    startLabel: PropTypes.string,
    titleTextComponent: PropTypes.string,
    titleIconComponent: PropTypes.object,
    primaryColor: PropTypes.string,
    secondaryColor: PropTypes.string
  };

  renderTitleInfo = () => {
    return (
      <TitleInfoWrapper>
        {this.props.titleTextComponent}
        {this.props.titleIconComponent}
      </TitleInfoWrapper>
    );
  }

  render() {
    return (
      <ContainerWrapper active={this.props.active} secondaryColor={this.props.secondaryColor}>
        <Container
          id= {this.props.id}
          active={this.props.active}
          onClick={() => {
            this.props.onSelection();
          }}>
          <TopBorder />
          <TitleWrapper>
            {(this.props.titleTextComponent || this.props.titleIconComponent) && this.renderTitleInfo()}
            <ConfigurationNameWrapper>
              <Title>
                {this.props.title} {this.props.technologyHint && <TechnologyHintWrapper>
                  <DropdownMenu
                    data-clickable
                    toggleElement={<InformationIcon />}
                    containerElement={<TechnologyHint>{this.props.technologyHint}</TechnologyHint>}
                  >
                  </DropdownMenu>
                </TechnologyHintWrapper>}
              </Title>
            </ConfigurationNameWrapper>
          </TitleWrapper>
          <Description>{this.props.description}</Description>
          <AdditionalDescription>{this.props.additionalDescription}</AdditionalDescription>
          <AlignBottom>
            <PreventExpand>
              {this.props.renderSelectedFilters && this.props.renderSelectedFilters()}
            </PreventExpand>
            <StartLabelWrapper><StartLabel primaryColor={this.props.primaryColor}>{this.props.startLabel}</StartLabel></StartLabelWrapper>
          </AlignBottom>
        </Container>
      </ContainerWrapper>
    );
  }
}

export default StartConfigurationCard;
